import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef,
  CdkTable,
} from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

import { AuthorizationToggleDirective } from 'ish-core/directives/authorization-toggle.directive';
import { Order } from 'ish-core/models/order/order.model';
import { PricePipe } from 'ish-core/models/price/price.pipe';
import { DatePipe } from 'ish-core/pipes/date.pipe';
import { AddressComponent } from 'ish-shared/components/address/address/address.component';
import { LoadingComponent } from 'ish-shared/components/common/loading/loading.component';

export type OrderColumnsType =
  | 'creationDate'
  | 'orderNo'
  | 'orderNoWithLink'
  | 'buyer'
  | 'lineItems'
  | 'status'
  | 'destination'
  | 'lineItems'
  | 'orderTotal';

/**
 * The Order List Component displays the orders provided as input parameter.
 *
 * @example
 * <ish-order-list
 *   [orders]="orders$ | async"
 *   [loading]="loading$ | async"
 *   [columnsToDisplay]="['creationDate', 'orderNoWithLink', 'lineItems', 'status', 'orderTotal']">
 * </ish-order-list>
 */
@Component({
  selector: 'ish-order-list',
  templateUrl: './order-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    CdkTable,
    CdkColumnDef,
    CdkHeaderCellDef,
    CdkHeaderCell,
    CdkCellDef,
    CdkCell,
    RouterLink,
    AddressComponent,
    CdkHeaderRowDef,
    CdkHeaderRow,
    CdkRowDef,
    CdkRow,
    LoadingComponent,
    DatePipe,
    PricePipe,
    TranslateModule,
    AuthorizationToggleDirective,
    InfiniteScrollDirective,
  ],
})
export class OrderListComponent {
  /**
   * The columns to be displayed.
   */
  readonly columnsToDisplay = input.required<OrderColumnsType[]>();

  /**
   * The orders to be displayed.
   */
  readonly orders = input.required<Partial<Order>[]>();

  readonly noOrdersMessageKey = input('account.orderlist.no_orders_message');

  readonly loading = input<boolean>(undefined);

  readonly view = input('OrderHistory'); //DIAS-CUSTOMIZATION

  /**DIAS-CUSTOMIZATION-STARTS */
  getBuyerNameUsingOrder(order: Partial<Order>): string {
    if (this.view() === 'CostCenter') {
      return order.attributes.reduce((acu, cur) => (acu += `${`${cur.value} `}`), '').trim();
    } else {
      return `${order?.user?.firstName} ${order?.user?.lastName} `;
    }
  }
  /**DIAS-CUSTOMIZATION-ENDS */
}
